import { render, staticRenderFns } from "./PPanelInputNumber.vue?vue&type=template&id=022ae021"
import script from "./PPanelInputNumber.vue?vue&type=script&lang=js"
export * from "./PPanelInputNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports